// extracted by mini-css-extract-plugin
export default {"fr-view":"Empty_fr-view__A+Gpe","container":"Empty_container__0e9yy","image":"Empty_image__LzrCU"};